import React from 'react'
import {connect} from "react-redux";
import {setSQFTActiveButton} from "../../../../actions/sqftMenuFunctions";
import {setSqftMeasureUnit} from "../../../../actions/sqftFunctions";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

const SqftPopupWindow = (props) => {
  const {title, content, isOpened} = props;
  const {confirmCallback, confirmText, cancelCallback, cancelText} = props;

  return (
    <div className={"message-box-overlay-settings " + (isOpened ? "" : "hidden")}>
      <div className="message-window-base">
        <div className="message-window-header-line">
          <div className="message-system-message-title message-system-message-title-settings">
            {title}
          </div>
          <button className="button button--close button--cancel"
                  onClick={() => cancelCallback()} >
          </button>
        </div>
        <div className="message-window-container">
          {content}
        </div>
        <div className="message-box-buttons message-box-buttons--modal">
          {
            cancelText ?
              <button className="ui-button10 ui-button10--blue"
                      onClick={() => cancelCallback()}>
                <span className="ui-button10--uppercase">
                  {cancelText}
                </span>
              </button>
              : null
          }
          {
            confirmText ?
              <button className="ui-button10 ui-button10--green"
                       onClick={() => confirmCallback()}>
                <span className="ui-button10--uppercase">
                  {confirmText}
                </span>
              </button>
              : null
          }
        </div>
      </div>
    </div>
  )
};

SqftPopupWindow.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.instanceOf(FormattedMessage)
  ]),
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.instanceOf(FormattedMessage)
  ]),
  isOpened: PropTypes.bool,
  confirmCallback: PropTypes.func,
  confirmText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.instanceOf(FormattedMessage)
  ]),
  cancelCallback: PropTypes.func,
  cancelText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.instanceOf(FormattedMessage)
  ]),
};

const mapStateToProps = (store) => ({
  activeButton: store.sqftMenuState.activeButton,
  measureUnit: store.sqftState.measureUnit,
});

const mapDispatchToProps = {
  setSQFTActiveButton,
  setSqftMeasureUnit
};

export default connect(mapStateToProps, mapDispatchToProps)(SqftPopupWindow);
